"use client";

import type { ReactNode } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import swipercss from "swiper/css?url";
import swiperpaginationcss from "swiper/css/pagination?url";

export function HeroCarousel({
  children,
  className,
  theme,
}: {
  children: ReactNode[];
  className?: string;
  theme?: string;
}) {
  return (
    <div
      className={`relative mx-auto mb-4 flex h-96 w-full flex-wrap justify-between ${className ?? ""} ${theme === "light" ? "text-white" : "text-black"}`}
    >
      <link rel="preload" href={swipercss} as="style" precedence="medium" />
      <link rel="preload" href={swiperpaginationcss} as="style" precedence="medium" />
      <link rel="stylesheet" href={swipercss} precedence="medium" />
      <link rel="stylesheet" href={swiperpaginationcss} precedence="medium" />
      <Swiper
        loop={true}
        pagination={{ clickable: true }}
        spaceBetween={0}
        fadeEffect={{ crossFade: true }}
        autoplay={{ delay: 8000, disableOnInteraction: false }}
        modules={[Autoplay, Pagination]}
        className="h-full w-full"
      >
        {children.map((child, i) => (
          <SwiperSlide key={i}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
